// This file was auto-generated by Fern from our API Definition.
const PathParameterLocationValues = {
    Root: "ROOT",
    Service: "SERVICE",
    Endpoint: "ENDPOINT",
};
export const PathParameterLocation = Object.assign(Object.assign({}, PathParameterLocationValues), { _visit: (value, visitor) => {
        switch (value) {
            case PathParameterLocation.Root:
                return visitor.root();
            case PathParameterLocation.Service:
                return visitor.service();
            case PathParameterLocation.Endpoint:
                return visitor.endpoint();
            default:
                return visitor._other();
        }
    } });
